import { ChildDropDownItem } from '../../../fields/child-dropdown-item.model';
import { Range } from '../../entities/range.model';
import { Table } from '../../entities/table.model';


export class ChildMdmDropDownItemsTable extends Table<{ [key: string]: ChildDropDownItem[]; }> {
  constructor(
    private permanentColumnsCount: number,
    range: Range) {
    super(range, false, {});
  }

  add(taxonomyId: number, fieldId: number, itemId: string, childItems: ChildDropDownItem[]): boolean {
    if (!this.exists(taxonomyId, fieldId, itemId)) {
      const columnDiff = childItems.length - (this.range.columnCount - this.permanentColumnsCount);

      if (columnDiff > 0) {
        this.range.columnCount += columnDiff;
      }

      if (this.containsData) {
        this.range.rowCount++;
      } else {
        this.containsData = true;
      }

      this.cache[this.getKey(taxonomyId, fieldId, itemId)] = childItems;
      return true;
    }

    return false;
  }

  remove(taxonomyId: number, fieldId: number, itemId: string): boolean {
    if (this.exists(taxonomyId, fieldId, itemId)) {
      delete this.cache[this.getKey(taxonomyId, fieldId, itemId)];

      if (this.range.rowCount == 2 /* header + one row */) {
        this.containsData = false;
      } else {
        this.range.rowCount--;
      }

      return true;
    }

    return false;
  }

  getChildItems(taxonomyId: number, fieldId: number, itemId: string): ChildDropDownItem[] {
    const childItems = this.cache[this.getKey(taxonomyId, fieldId, itemId)];
    return childItems ? [...childItems] : undefined;
  }

  getRowPosition(taxonomyId: number, fieldId: number, itemId: string): number {
    if (this.exists(taxonomyId, fieldId, itemId)) {
      return Object
        .keys(this.cache)
        .indexOf(this.getKey(taxonomyId, fieldId, itemId));
    }

    return -1;
  }

  exists(taxonomyId: number, fieldId: number, itemId: string): boolean {
    return this.cache.hasOwnProperty(this.getKey(taxonomyId, fieldId, itemId));
  }

  private getKey(taxonomyId: number, fieldId: number, itemId: string): string {
    return [taxonomyId, fieldId, itemId].join('|');
  }
}